import { cn } from "@/shared/cn";

export const INPUT_CLASS = cn(
  "block w-full min-w-0 rounded-[11px] border border-(--line-strong) bg-(--paper)",
  "px-[12px] py-[9px] text-md text-(--ink) placeholder:text-(--muted)",
  "transition-[border-color,box-shadow] duration-(--duration-fast)",
  "focus:border-(--brand) focus:shadow-[0_0_0_3px_var(--brand-soft)] focus:outline-none",
  "disabled:border-(--line) disabled:bg-[color-mix(in_srgb,var(--ink)_8%,transparent)] disabled:text-(--dim)",
  "[&:is(input,textarea):read-only]:border-(--line) [&:is(input,textarea):read-only]:text-(--dim)",
  "[&:is(input,textarea):read-only]:bg-[color-mix(in_srgb,var(--ink)_8%,transparent)]",
  "aria-[invalid=true]:border-(--bad)",
);

export const LABEL_CLASS = "text-sm font-medium text-(--ink)";
